import serviceImg1 from "../Images/service1.png";
import serviceImg2 from "../Images/service2.png";
import serviceImg3 from "../Images/service3.png";
import otherdetails1 from "../Images/otherdetails.png";
import otherdetails2 from "../Images/ecommerceAuto.webp";
import otherdetails3 from "../Images/digitalTranformation.webp";


const automationDetails = [
    {
      id:1,
      title: "WhatsApp",
      title_highlight:"Automation",
      description: "Tech It Easy offers WhatsApp automation services to streamline customer interactions, appointment scheduling, and business communications. Our solutions include chatbot integration, automated replies, order tracking, and CRM synchronization—enhancing efficiency and customer engagement.",
      featureDescription: "WhatsApp automation can reduce customer response time by up to 80%, ensuring businesses reply faster than a human could type 'Hi!'",
      featureTitle:"How WhatsApp Automation benefits ",
      title_s:"Non-Users",
      featureLists: [
        { title: "Time Efficiency", description: "Automate responses, scheduling, and FAQs to save hours daily." },
        { title: "Increase Customer Engagement", description: "Send personalized messages, automate follow-ups, and boost interactions." },
        { title: "24/7 Availability", description: "Provide instant support anytime, improving customer satisfaction." },
        { title: "Analysis & Insights", description: "Track conversations, measure performance, and optimize responses." },
        { title: "Stay Ahead of Competitors", description: "Enhance customer service and streamline operations effortlessly." }
            ],
      homeImg:serviceImg1,
      img:otherdetails1
    },
    {
        id:2,
      title: "Ecommerce",
      title_highlight:"Automation",
      description: "At Tech It Easy, we help businesses automate their e-commerce operations, reducing manual work and maximizing efficiency.",
      featureTitle:"How Ecommerce Automation benefits",
      title_s:"Non-Users",
      featureDescription: "Did you know? 80% of e-commerce businesses that use automation see a boost in sales within just 6 months!",
      featureLists: [
        { title: "Order & Inventory Management", description: "Automate stock updates, track orders in real-time, and prevent overselling." },
        { title: "Automated Customer Support", description: "Use AI-driven chatbots for instant replies, order tracking, and FAQs." },
        { title: "Marketing & Sales Automation", description: "Set up auto-replies, personalized discounts, and abandoned cart recovery." },
        { title: "Seamless Multi-Channel Integration", description: "Sync your store across Amazon, Flipkart, Shopify, and more." },
        { title: "Analytics & Insights", description: "Track customer behavior, sales trends, and optimize for higher conversions." }      
      ],
      homeImg:serviceImg2,
      img:otherdetails2

    },
    {
      id:3,
      title: "Digital",
      title_highlight:"Transformation",
      description: "Tech It Easy empowers businesses with cutting-edge digital transformation solutions, helping them streamline operations, enhance customer experiences, and drive growth.",
      featureTitle:"How Digital Transformation benefits",
      title_s:"Non-Users",
      featureDescription: "Over 90% of the world’s data was created in just the last two years!",
      featureLists: [
        { title: "Process Automation", description: "Reduce manual work with AI-driven automation." },
        { title: "E-Commerce Solutions", description: "Build and optimize online stores for seamless sales." },
        { title: "Cloud Integration", description: "Secure, scalable, and efficient cloud-based solutions." },
        { title: "Data & Analytics", description: "Gain actionable insights to make smarter business decisions." },
        { title: "AI & Chatbot Solutions", description: "Enhance customer support with intelligent automation." },
        { title: "Custom Software Development", description: "Tailor-made solutions for unique business needs." }
            ],
      homeImg:serviceImg3,
      img:otherdetails3
    },
  ];
  
export {automationDetails}  